import { Modal as MUIModal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function Modal({ title, isOpened, onClose, children }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <MUIModal
      open={isOpened}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '70%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          overflow: 'auto',
          maxHeight: '80vh',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography id="modal-title" variant="h6">
            {title}
          </Typography>
          <IconButton onClick={handleClose} color="primary">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box id="modal-description" mt={2}>
          {children}
        </Box>
      </Box>
    </MUIModal>
  );
}
